export const previewAvatar = { width: '85px', height: '85px' };
